module.exports = __webpack_public_path__ + "static/media/img_Inscription_free1@2x.64143d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_free1@2x.png
// module id = 982
// module chunks = 0